module.exports = __webpack_public_path__ + "img/wx.45e68156.png";